import './styles.scss'

import Skeleton from 'react-loading-skeleton'

interface TagProps {
  isLoading?: boolean
  name: string
}

function Tag(props: TagProps) {
  const { isLoading = false, name } = props
  return (
    <div className="tag__wrapper">
      <div className="tag__arrow--left" />
      <div className="tag__name">
        {isLoading ? <Skeleton width={63} /> : name}
      </div>
      <div className="tag__arrow--right" />
    </div>
  )
}

export default Tag
